export const RestaurantIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5682 9.35091H14.1816C14.6152 9.3521 15.0448 9.26725 15.4454 9.10128C15.846 8.93531 16.2098 8.69152 16.5155 8.38401L19.8918 4.98091L18.9752 4.05692L15.5276 7.50457L14.8111 6.78806L18.2587 3.34L17.31 2.41971L13.8751 5.85417L13.1607 5.13766L16.6083 1.68959L15.6843 0.773438L12.2812 4.14973C11.9737 4.45554 11.7299 4.81932 11.5639 5.22002C11.3979 5.62071 11.3131 6.05035 11.3143 6.48405V7.09702L9.53523 8.87612L1.41192 0.773438C-0.414619 3.03681 0.664061 7.19643 2.72036 9.25314L6.24721 12.78C7.34239 13.8752 7.55978 13.9729 8.80222 13.473C9.06993 13.3653 9.16728 13.3773 9.41684 13.6264L9.95309 14.1268C10.0739 14.2505 10.0768 14.2868 10.0768 14.5236V14.7521C10.0768 15.6217 10.6329 16.1216 10.9992 16.4945L15.2718 20.5733L18.2418 17.6033L11.7891 11.13L13.5682 9.35091Z"
      fill="currentColor"
    />
    <path
      d="M8.81075 14.7402C7.58068 14.9922 6.82623 15.2244 5.38372 13.7819C5.36062 13.7588 5.3367 13.7366 5.3136 13.7135L4.50923 12.9091L0.0917969 17.2733L3.39177 20.5733L9.33174 14.6333L8.81075 14.7402Z"
      fill="currentColor"
    />
  </svg>
);
